import CommonCreate from "@/components/common/Create"
import ServiceForm from "../forms/ServiceForm"
import React from "react";
import { SelectedValue } from "@/interface/dataInterface";
import { mergeDateAndTime } from "@/utils/formChange";

const ServiceCreate = () => {
  const [formProp, setFormProp] = React.useState({
    date: new Date(),
    time: "",
    vehicle_id: "",
    odometer: 0,
    service_type_list: [],
    notes: "",
  });
  const [otherData, setOtherData] = React.useState<SelectedValue[]>([]);
  
  return (
    <CommonCreate title="Create Service" resource="service" data={{...formProp, date: mergeDateAndTime(formProp.date, formProp.time), vehicle_id: +formProp.vehicle_id, service_type_list: otherData}}>
      <ServiceForm formProp={formProp} setFormProp={setFormProp} otherData={otherData} setOtherData={setOtherData} />
    </CommonCreate>
  )
}

export default ServiceCreate;